/**
 * Created by Mark on 24/11/2016.
 */


import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    GET_SIDE_MENU_COMPONENTS: ENVIRONMENT_CONSTANTS.BASE_URL + 'adminComponents/getSideMenu',
    GET_MENU_ITEMS: ENVIRONMENT_CONSTANTS.BASE_URL + 'adminNavigation/get/',
    UPDATE_SIDE_MENU_COMPONENTS: 'UPDATE_SIDE_MENU_COMPONENTS',
    UPDATE_MENU_ITEMS_COMPONENTS: 'UPDATE_MENU_ITEM_COMPONENTS',
    UPDATE_MOBILE_MENU_TOGGLED:'UPDATE_TOGGLE_SIDE_BAR'
}


// WEBPACK FOOTER //
// ./src/constants/navigation.js